export function setLocalStore(key: string, value: any) {
  if (value === undefined) {
    localStorage.removeItem(key);
    return;
  }
  const serialized = JSON.stringify(value);
  if (serialized === undefined) {
    localStorage.removeItem(key);
    return;
  }
  localStorage.setItem(key, serialized);
}

export function getLocalStore(key: string) {
  const raw = localStorage.getItem(key);
  if (raw == null || raw === "" || raw === "undefined") {
    return {};
  }
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function removeLocalStore(key: string) {
  localStorage.removeItem(key);
}

export function clearLocalStore() {
  localStorage.clear();
}

export function setObjectInLocalStore(key: string, object: object) {
  if (object) {
    setLocalStore(key, object);
  }
}

export function getObjectFromLocalStore(key: string) {
  try {
    const objectString = getLocalStore(key);
    return objectString;
  } catch (e) {
    return {};
  }
}

// userId, email, userType etc. for the logged-in user live inside the JWT claims, not as
// top-level keys on the "useraccess" local-store entry, so callers must decode access_token.
export function getLoggedInUserTokenPayload(): Record<string, any> | null {
  const userAccess = getObjectFromLocalStore("useraccess");
  const token = userAccess?.access_token;
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}

export function getLoggedInUserId(): string {
  return getLoggedInUserTokenPayload()?.userId ?? "";
}
